import { useCompanySaleCheck } from "context/useCompanySaleCheck";
import { useOrders } from "context/useOrderData";
import { useProductConfiguration } from "context/useProductConfiguration";
import { WebshopId } from "models/WebShop";
import { Link, useParams } from "react-router-dom";
import { UrlPath } from "utility/routes";

const BulletpointsPromo = () => {
    const params = useParams();
    const companyId = params.id ?? "";
    const { companySaleCheck } = useCompanySaleCheck();
    const { saleStatusByCompany } = useOrders();
    const { productConfigurationsByCompany } = useProductConfiguration();

    const path = `${UrlPath.Account.WebShopBase}/${companyId}/${UrlPath.Account.ProductConfig.BulletPoints}`;

    if (companyId === "" || companySaleCheck[companyId] === undefined)
        return null;

    const showSalePromo = companySaleCheck[companyId]?.allowed && !saleStatusByCompany[companyId]?.orderStatuses.some(x => x.activeProducts.some(p => p.id === WebshopId.bulletPoints))  && productConfigurationsByCompany[companyId]?.bulletPoints === null;
    const showConfig = productConfigurationsByCompany[companyId].bulletPoints !== undefined && productConfigurationsByCompany[companyId].bulletPoints !== null;

    return showSalePromo ? (
        <div className="card mt-4">
            <div className="card-header">
                <h2 className="fs-5">Punktliste</h2>
            </div>
            <div className="card-body">
                <Link to={path}><img src="/min-bedrift-ill-punktliste.svg" width="800" height="520" alt="" className="cc-card-shop-promo-ill" /></Link>
                <p>Oppsummer din bedrifts virksomhet i fem punkter.</p>
                <p className="mb-0"><Link to={path} className="btn btn-primary text-white">Kjøp punktliste</Link></p>
            </div>
        </div>
    ) :
        (showConfig ?
            <div className="card mt-4">
                <div className="card-header">
                    <h2 className="fs-5">Punktliste</h2>
                </div>
                <div className="card-body">
                    <ul>
                        {productConfigurationsByCompany[companyId].bulletPoints?.bulletPoints.filter(b => b !== "").map((b, i) => (
                            <li key={i}>{b}</li>
                        ))}
                    </ul>
                    <div className="mb-0 d-md-flex justify-content-between align-items-center">
                        <div>
                            <Link
                                to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.BulletPoints}`}
                                className="btn btn-primary text-white">Endre punktliste</Link>
                        </div>
                        <div className="mt-3 mt-md-0">
                            <Link
                                to={`${UrlPath.Account.Company}/${params.id}/${UrlPath.Account.Actions.Products}/${UrlPath.Account.ProductConfig.BulletPoints}`}
                                className="cc-icon-text-link text-muted"><i className="bi bi-box"></i> <span>Kjøpt produkt</span></Link>
                        </div>
                    </div>
                </div>
            </div> :
            null
        )
};

export default BulletpointsPromo;